let I18nFactory = ($translate, tmhDynamicLocale, Localization, $rootScope, $log, $state, $location) => {
  'ngInject'
  const config = Localization.getLocalizedAppConfig()

  let isLocaleInAppConfig = (locale) => {
    return config.locales.find((lang) => { return (lang === locale) })
  }

  let getDefaultLanguage = () => {
    const lang = navigator.language.split('-')[0]
    const defaultLanguage = isLocaleInAppConfig(lang) ? lang : config.locales[0]
    return defaultLanguage
  }

  let changeLanguage = (locale) => {
    if (isLocaleInAppConfig(locale)) {
      return $translate.use(locale).then(() => {
        tmhDynamicLocale.set(locale)
        $log.debug('New locale: ', $translate.use())
        $rootScope.$broadcast('language:changed', locale)
        if ($state.current.name && !$location.url().includes('locale')) {
          return $state.reload()
        } else {
          return Promise.resolve()
        }
      })
    } else {
      return Promise.resolve()
    }
  }

  let getLanguage = () => {
    return $translate.use() || getDefaultLanguage()
  }

  let isArLocale = () => {
    return getLanguage() === 'ar'
  }
  return { getDefaultLanguage, changeLanguage, getLanguage, isArLocale }
}

export default I18nFactory



// WEBPACK FOOTER //
// ./src/app/common/i18n/i18n.factory.js